import { useEffect, useState } from "react";
import { useShellHost } from "@/shell-handle/ShellHostProvider";

export const usePermissions = () => {
  const host = useShellHost();
  const [permissions, setPermissions] = useState(host.handle.permissions.raw());

  useEffect(() => {
    setPermissions(host.handle.permissions.raw());
    return host.handle.permissions.onChange(() => {
      setPermissions(host.handle.permissions.raw());
    });
  }, [host]);

  const hasPermission = (permissionName: string) =>
    permissions.find((p) => p.name === permissionName)?.active ?? false;

  return { hasPermission, permissions };
};
